import { useCallback, useRef, useState } from "react";
import {
  getReportingFields,
  isGameLadderType,
  extractGameScores,
} from "../utils/ladder-util";
import type { ActivityResult, CompletionDisplayData } from "../types";

interface UseSubmissionExtractorOptions {
  ladderType?: string;
  onActivitySubmitted: (
    result: ActivityResult,
  ) => Promise<CompletionDisplayData>;
  onSubmissionComplete: (data: CompletionDisplayData) => void;
}

export const useLearnositySubmissionExtractor = ({
  ladderType,
  onActivitySubmitted,
  onSubmissionComplete,
}: UseSubmissionExtractorOptions) => {
  const [submitting, setSubmitting] = useState(false);
  const onActivitySubmittedRef = useRef(onActivitySubmitted);
  onActivitySubmittedRef.current = onActivitySubmitted;
  const onSubmissionCompleteRef = useRef(onSubmissionComplete);
  onSubmissionCompleteRef.current = onSubmissionComplete;

  const handleSubmitted = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async (itemsApi: any, divId: string) => {
      try {
        setSubmitting(true);
        const rawScores = itemsApi.getScores();
        const responses = itemsApi.getResponses();
        const tags = itemsApi.getTags();
        const items = itemsApi.getItems();
        const time = itemsApi.getTime();

        const scores = isGameLadderType(ladderType)
          ? extractGameScores(rawScores, responses)
          : rawScores;

        const result: ActivityResult = {
          scores,
          responses,
          tags,
          items,
          time,
          sessionId: itemsApi.forSessionId || "",
          reportingFields: getReportingFields(itemsApi),
        };

        const completionData = await onActivitySubmittedRef.current(result);

        // Hide the learnosity div
        const el = document.getElementById(divId);
        if (el) el.style.display = "none";

        onSubmissionCompleteRef.current(completionData);
      } catch (error) {
        console.error("Error onActivitySubmitted", error);
      } finally {
        setSubmitting(false);
      }
    },
    [ladderType],
  );

  return { submitting, handleSubmitted };
};
